export interface IOlNamesConfig {
  variable_wage_1: string;
  variable_wage_2: string;
  grupo_salarial: string;
}

export enum DEFAULT_OL_NAMES {
  VARIABLE_WAGE_1 = 'Hiring Bônus',
  VARIABLE_WAGE_2 = 'ILP',
  GRUPO_SALARIAL = 'Grupo Salarial',
}
